module.exports = __webpack_public_path__ + "static/img/11074C_C_2_4_20180322_LC.86db37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11074C_C_2_4_20180322_LC.png
// module id = pxAB
// module chunks = 0